import { Component, store, constant, setState } from "../..";
import { DEDICATED_IP_ICON, addonIconMap } from "../../constants/addonIcons";
import { numberFormat, getTranslation, addCurrencySymbol, removeAddon, addAddon, updateTeamsCounter} from "..";

export default class TeamsVpnAddons extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('.pro-teams-vpn-addons'),
      state: store.state,
    });
  }

  render() {
    const elementOne = document.querySelector('.pure-teams-box-v1');

    const {teamsAddonList, DEDICATED_IP, TEAM_SERVER, RESIDENTIAL_NETWORK_BANDWIDTH, PORT_FORWARDING} = constant;

    let addonsOneHtml = '';

    const addonsToBeDisplay = teamsAddonList;

    // Getting Selected Plan Details
    const selectedPlan = this.state.selected_plan ? this.state.selected_plan : {};
    const planGroup = JSON.parse(selectedPlan?.description || '{}')?.plan_group;

    // Addons specific order
    const addonListOrder = {
      [TEAM_SERVER]: 1,
      [DEDICATED_IP]: 2,
      [RESIDENTIAL_NETWORK_BANDWIDTH]: 3,
      [PORT_FORWARDING]: 4,
    };

    const addonList = (selectedPlan?.addons || [])
      .filter(item => addonsToBeDisplay.includes(item.code))
      .sort((a, b) => {
        const orderA = addonListOrder[a.code] || 0;
        const orderB = addonListOrder[b.code] || 0;
        return orderA - orderB;
      });

    // Getting Addons Details
    const selectedAddons = this.state.selected_addons || [];
    const disabledAddons = this.state.disable_addons || [];

    const currencyCode = this.state.currency_code;
    const oldPrices = this.state.old_prices;

    const oldAddonPrices = oldPrices[currencyCode] || {};

    // Getting Addon Strip HTML
    const full_suit = document.querySelector('#teams-vpn-addons');
    full_suit.classList.add('show');

    const teamQuantity = this.state.teamQuantity;

    const dIPStartRange = 0;
    const dedicatedIpsQuantity = this.state?.dedicatedIpsQuantity;
    const dIPMidValue = dedicatedIpsQuantity < dIPStartRange ? dIPStartRange : dedicatedIpsQuantity;

    const pfStartRange = 0;
    const portFowardingQuantity = this.state?.portFowardingQuantity;
    const pfMidValue = portFowardingQuantity < pfStartRange ? pfStartRange : portFowardingQuantity;

    let count = 0;
    // Check if there are addons in the list
    if (addonList?.length) {
      for (const addon of addonList) {
        count++;
        const addonTitle = getTranslation(
          addon.code === DEDICATED_IP ? 'teams_dedicated_ips_v2' : addon.code === PORT_FORWARDING ? 'teams_port_forwarding_v2' : addon.code,
        );
        const priceOldAddon = oldAddonPrices[addon?.code] ? Number(oldAddonPrices[addon?.code]) : 0;

        // Calculate the addon price based on the unit amount and selected plan interval length
        const addonPrice = addon?.unit_amount ? Number(addon.unit_amount) / Number(selectedPlan.interval_length) : 0;

        let addonsHtml = '';

        if (addon.state === 'active') {
          addonsHtml += `
          <div data-eventname="cro_addon_click" data-eventparamkey="position|element_text" data-eventparamvalue="addon_stripe_box_click|${
            addon.code
          }" class="special-addon-box vpn-addon-box ${
            selectedAddons.includes(addon.code) || selectedAddons.includes(`${addon.code}_discounted`) ? 'active' : ''
          } ${disabledAddons.includes(addon.code) ? 'disabled' : ''}" addon-code="${addon.code}">

            <div class="p-vpn-top-sec">
              <div class="p-vpn-hdg">
                <div class="p-vpn-hdg-top">
                  ${addonIconMap[addon?.code] || DEDICATED_IP_ICON}

                  <div class="vpn-top-box">
                    <span class="heading-box">
                      <h3>${addonTitle}</h3>
                      <i data-eventname="cro_info_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_stripe|${
                        addon.code
                      }" class="popup_link" addon-code="${addon.code}">
                        <svg class="icon-helper" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.5" d="M6.1002 9.59377C6.26946 9.59377 6.41144 9.53642 6.52614 9.42172C6.64084 9.30702 6.69799 9.16524 6.69759 8.99638V6.60679C6.69759 6.43752 6.64024 6.29554 6.52554 6.18084C6.41084 6.06614 6.26906 6.00899 6.1002 6.00939C5.93093 6.00939 5.78895 6.06674 5.67425 6.18144C5.55955 6.29614 5.5024 6.43792 5.5028 6.60679V8.99638C5.5028 9.16564 5.56015 9.30762 5.67485 9.42232C5.78955 9.53702 5.93133 9.59417 6.1002 9.59377ZM6.1002 4.8146C6.26946 4.8146 6.41144 4.75724 6.52614 4.64254C6.64084 4.52784 6.69799 4.38606 6.69759 4.2172C6.69759 4.04794 6.64024 3.90595 6.52554 3.79125C6.41084 3.67655 6.26906 3.6194 6.1002 3.6198C5.93093 3.6198 5.78895 3.67715 5.67425 3.79185C5.55955 3.90655 5.5024 4.04833 5.5028 4.2172C5.5028 4.38646 5.56015 4.52844 5.67485 4.64314C5.78955 4.75784 5.93133 4.81499 6.1002 4.8146ZM6.1002 12.5808C5.2738 12.5808 4.49718 12.4238 3.77035 12.11C3.04351 11.7962 2.41127 11.3706 1.87361 10.8334C1.33595 10.2957 0.910405 9.66347 0.59697 8.93664C0.283535 8.2098 0.126619 7.43319 0.126221 6.60679C0.126221 5.78039 0.283137 5.00377 0.59697 4.27694C0.910803 3.5501 1.33635 2.91786 1.87361 2.3802C2.41127 1.84254 3.04351 1.417 3.77035 1.10356C4.49718 0.790127 5.2738 0.633211 6.1002 0.632812C6.9266 0.632812 7.70321 0.789729 8.43005 1.10356C9.15688 1.41739 9.78913 1.84294 10.3268 2.3802C10.8644 2.91786 11.2902 3.5501 11.604 4.27694C11.9179 5.00377 12.0746 5.78039 12.0742 6.60679C12.0742 7.43319 11.9173 8.2098 11.6034 8.93664C11.2896 9.66347 10.864 10.2957 10.3268 10.8334C9.78913 11.371 9.15688 11.7968 8.43005 12.1106C7.70321 12.4244 6.9266 12.5812 6.1002 12.5808Z" fill="#949C9E"/>
                        </svg>
                      </i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="pvpn-price-checkbox-box">
              <div class="pvpn-price-box">
              <span class="pvpn-cut-price">
                ${priceOldAddon > addonPrice ? addCurrencySymbol(numberFormat(priceOldAddon)) : ''}
              </span>
              <p>
                ${addCurrencySymbol(numberFormat(addonPrice))}
                <span>/${getTranslation('mo')}</span>
              </p>
              </div>
              ${getAddonMarkup(addon)}
            </div>
          </div>
        `;
        }

        addonsOneHtml += addonsHtml;
      }
    }

    /* Removing special addon boxes before appending new addon boxes */
    const addonBoxes = this.element.querySelectorAll('.special-addon-box') || [];
    addonBoxes.forEach(box => {
      box.remove();
    });

    if (elementOne) {
      elementOne.innerHTML = addonsOneHtml;
    }

    function getAddonMarkup(addon) {
      const isPF = addon.code === PORT_FORWARDING;
      const isDIP = addon.code === DEDICATED_IP;

      const powerPackCond = selectedAddons.includes(addon.code);

      const baseClass = isPF ? 'pf' : isDIP ? 'vpn' : '';
      const startRange = isPF ? pfStartRange : isDIP ? dIPStartRange : null;
      const midValue = isPF ? pfMidValue : isDIP ? dIPMidValue : null;

      const minusSvg = `
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11" cy="11" r="11" fill="#E5E7EB" fill-opacity="0.7"></circle>
          <path d="M14.8714 10.0189V12.2263H7.13281V10.0189H14.8714Z" fill="#001219"></path>
        </svg>
      `;

      const plusSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path d="M11.0004 20.7782C16.4006 20.7782 20.7782 16.4006 20.7782 11.0004C20.7782 5.60032 16.4006 1.22266 11.0004 1.22266C5.60032 1.22266 1.22266 5.60032 1.22266 11.0004C1.22266 16.4006 5.60032 20.7782 11.0004 20.7782Z" fill="#7C30F7"></path>
          <path d="M11.0004 7.08932V14.9115M7.08932 11.0004H14.9115M20.7782 11.0004C20.7782 16.4006 16.4006 20.7782 11.0004 20.7782C5.60032 20.7782 1.22266 16.4006 1.22266 11.0004C1.22266 5.60032 5.60032 1.22266 11.0004 1.22266C16.4006 1.22266 20.7782 5.60032 20.7782 11.0004Z" stroke="white" stroke-width="2.25635" stroke-linecap="round" stroke-linejoin="round"></path>
          <circle cx="11" cy="11" r="9.5" stroke="#7C30F7" stroke-width="3"></circle>
        </svg>
      `;

      if (isPF || isDIP) {
        return `
          <div class="${baseClass}-teams-field-box">
            <button class="${baseClass}-team-input-btn minus" data-eventname="cro_addon_click" data-eventparamkey="position|element_text" data-eventparamvalue="dips_count|minus">
              ${minusSvg}
            </button>
            <div class="${baseClass}-input-bubble">
              <input class="${baseClass}-team-input-number" type="number" min="${startRange}" max="${teamQuantity}" value="${midValue}">
            </div>
            <button class="${baseClass}-team-input-btn plus" data-eventname="cro_addon_click" data-eventparamkey="position|element_text" data-eventparamvalue="dips_count|add">
              ${plusSvg}
            </button>
          </div>
        `;
      }

      return `
        <div class="addon-btn pvpn-checkbox ${powerPackCond ? 'active' : ''}" 
             data-eventname="cro_addon_click"  
             data-eventparamkey="position|element_text"  
             data-eventparamvalue="addon_stripe_cta|${addon.code}" 
             addon-code="${addon.code}">
          <div class="vpn-addon-button-label">
            <button type="button" id="${addon.code}" class="vpn-addon-btn ${powerPackCond ? 'icon-check' : 'icon-plus'}"></button>
          </div>
          <div class="vpn-addon-text ${powerPackCond ? 'vpn-addon-added' : 'vpn-addon-add'}">
            ${powerPackCond ? 'Added' : 'Add'}
          </div>  
        </div>
      `;
    }

    function setupAddonCounter({addonCode, inputSelector, hiddenInputSelector, btnSelector, quantityKey}) {
      const inputField = document.querySelector(inputSelector);
      const hiddenInput = document.querySelector(hiddenInputSelector);
      const teamFieldAll = document.querySelectorAll('.team-input-number');
      const teamField = document.querySelector('.cart-box .team-input-number');

      if (!inputField || !teamField) return;

      const teamsMaxValue = Number(teamField.max);

      document.querySelectorAll(btnSelector).forEach(btn => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const isMinus = this.classList.contains('minus');
          const currentValue = Number(inputField.value);
          const minValue = Number(inputField.min);
          const maxValue = Number(inputField.max);

          if ((isMinus && currentValue > minValue) || (!isMinus && currentValue < maxValue)) {
            inputField.value = isMinus ? currentValue - 1 : currentValue + 1;

            if (inputField.value > 0) {
              addAddon(addonCode, null, false, null, planGroup);
            } else {
              removeAddon(addonCode);
            }

            setState({[quantityKey]: inputField.value});
            hiddenInput.value = inputField.value;
          } else if (!isMinus && currentValue === maxValue) {
            if (currentValue + 1 <= teamsMaxValue) {
              inputField.value = currentValue + 1;
              hiddenInput.value = inputField.value;

              const updatedValue = inputField.value;
              const updatedObj = {
                [quantityKey]: updatedValue,
                teamQuantity: updatedValue,
              };

              if (updatedValue > 0) {
                addAddon(addonCode, null, false, null, planGroup);
              }

              setState(updatedObj);
              updateTeamsCounter(updatedValue, teamFieldAll);
            }
          }
        });
      });

      inputField.addEventListener('input', function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.value = this.value.replace(/\D/, '');
      });

      inputField.addEventListener('change', function (e) {
        e.preventDefault();
        e.stopPropagation();

        setState({[quantityKey]: this.value});
        hiddenInput.value = this.value;
      });

      inputField.addEventListener('blur', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const value = Number(this.value);
        const minValue = Number(this.min);
        const maxValue = Number(this.max);
        let updatedObj = {[quantityKey]: value};

        if (value > teamsMaxValue) {
          updatedObj = {[quantityKey]: teamsMaxValue, teamQuantity: teamsMaxValue};
          updateTeamsCounter(teamsMaxValue, teamFieldAll);
          this.value = teamsMaxValue;
        } else if (value > maxValue) {
          updateTeamsCounter(value, teamFieldAll);
          updatedObj.teamQuantity = value;
        } else if (isNaN(value) || value < minValue) {
          this.value = minValue;
        }

        if (value > 0) {
          addAddon(addonCode, null, false, null, planGroup);
        } else {
          removeAddon(addonCode);
        }

        setState(updatedObj);
        hiddenInput.value = this.value;
      });

      inputField.addEventListener('wheel', e => e.preventDefault());

      inputField.addEventListener('keydown', event => {
        if (event.key === 'Enter') inputField.blur();
      });
    }

    setupAddonCounter({
      addonCode: DEDICATED_IP,
      inputSelector: '.vpn-team-input-number',
      hiddenInputSelector: '#dedicated-no',
      btnSelector: '.vpn-team-input-btn',
      quantityKey: 'dedicatedIpsQuantity',
    });

    setupAddonCounter({
      addonCode: PORT_FORWARDING,
      inputSelector: '.pf-team-input-number',
      hiddenInputSelector: '#port-forwarding-no',
      btnSelector: '.pf-team-input-btn',
      quantityKey: 'portFowardingQuantity',
    });
  }
}
